export default __webpack_public_path__ + "static/media/xlsx.064d3bbc.png";